import { Map } from 'immutable';

import {
  ADD_ERROR,
  REMOVE_ERROR,
} from './actions';

export default function apiError(state = new Map({}), action) {
  switch (action.type) {
    case ADD_ERROR:
      return state.set(action.pathName, action.payload);
    case REMOVE_ERROR:
      return state.delete(action.pathName);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/ApiError/reducer.js